export interface AgentTool {
    name: string
    titleKey: string
    category: ToolCategory
    descriptionKey: string
}

export enum ToolCategory {
    PATIENT = 'page.medconnectAgent.toolCategories.patient',
    DOCUMENT = 'page.medconnectAgent.toolCategories.document',
    CONSULTATION = 'page.medconnectAgent.toolCategories.consultation',
    STAFF = 'page.medconnectAgent.toolCategories.staff',
    WAITING_ROOM = 'page.medconnectAgent.toolCategories.waitingRoom',
    FORM = 'page.medconnectAgent.toolCategories.form',
    VIDAL = 'page.medconnectAgent.toolCategories.vidal',
    KNOWLEDGE_BASE = 'page.medconnectAgent.toolCategories.knowledgeBase',
    META = 'page.medconnectAgent.toolCategories.meta',
}

export const availableTools: AgentTool[] = [
    // Patient Tools
    {
        name: 'get_or_create_patient',
        titleKey: 'page.medconnectAgent.tools.get_or_create_patient_title',
        category: ToolCategory.PATIENT,
        descriptionKey: 'page.medconnectAgent.tools.get_or_create_patient_desc',
    },
    {
        name: 'create_patient',
        titleKey: 'page.medconnectAgent.tools.create_patient_title',
        category: ToolCategory.PATIENT,
        descriptionKey: 'page.medconnectAgent.tools.create_patient_desc',
    },
    {
        name: 'search_patients',
        titleKey: 'page.medconnectAgent.tools.search_patients_title',
        category: ToolCategory.PATIENT,
        descriptionKey: 'page.medconnectAgent.tools.search_patients_desc',
    },
    {
        name: 'get_patient_details',
        titleKey: 'page.medconnectAgent.tools.get_patient_details_title',
        category: ToolCategory.PATIENT,
        descriptionKey: 'page.medconnectAgent.tools.get_patient_details_desc',
    },
    {
        name: 'update_patient',
        titleKey: 'page.medconnectAgent.tools.update_patient_title',
        category: ToolCategory.PATIENT,
        descriptionKey: 'page.medconnectAgent.tools.update_patient_desc',
    },
    {
        name: 'add_patient_file',
        titleKey: 'page.medconnectAgent.tools.add_patient_file_title',
        category: ToolCategory.PATIENT,
        descriptionKey: 'page.medconnectAgent.tools.add_patient_file_desc',
    },

    // Document Tools
    {
        name: 'list_patient_files',
        titleKey: 'page.medconnectAgent.tools.list_patient_files_title',
        category: ToolCategory.DOCUMENT,
        descriptionKey: 'page.medconnectAgent.tools.list_patient_files_desc',
    },
    {
        name: 'get_document_content',
        titleKey: 'page.medconnectAgent.tools.get_document_content_title',
        category: ToolCategory.DOCUMENT,
        descriptionKey: 'page.medconnectAgent.tools.get_document_content_desc',
    },
    {
        name: 'list_session_files',
        titleKey: 'page.medconnectAgent.tools.list_session_files_title',
        category: ToolCategory.DOCUMENT,
        descriptionKey: 'page.medconnectAgent.tools.list_session_files_desc',
    },

    // Consultation Tools
    {
        name: 'schedule_consultation',
        titleKey: 'page.medconnectAgent.tools.schedule_consultation_title',
        category: ToolCategory.CONSULTATION,
        descriptionKey: 'page.medconnectAgent.tools.schedule_consultation_desc',
    },
    {
        name: 'search_consultations',
        titleKey: 'page.medconnectAgent.tools.search_consultations_title',
        category: ToolCategory.CONSULTATION,
        descriptionKey: 'page.medconnectAgent.tools.search_consultations_desc',
    },
    {
        name: 'get_consultation_details',
        titleKey: 'page.medconnectAgent.tools.get_consultation_details_title',
        category: ToolCategory.CONSULTATION,
        descriptionKey: 'page.medconnectAgent.tools.get_consultation_details_desc',
    },
    {
        name: 'list_patient_consultations',
        titleKey: 'page.medconnectAgent.tools.list_patient_consultations_title',
        category: ToolCategory.CONSULTATION,
        descriptionKey: 'page.medconnectAgent.tools.list_patient_consultations_desc',
    },
    {
        name: 'add_biological_test_result',
        titleKey: 'page.medconnectAgent.tools.add_biological_test_result_title',
        category: ToolCategory.CONSULTATION,
        descriptionKey: 'page.medconnectAgent.tools.add_biological_test_result_desc',
    },
    {
        name: 'list_patient_prescriptions',
        titleKey: 'page.medconnectAgent.tools.list_patient_prescriptions_title',
        category: ToolCategory.CONSULTATION,
        descriptionKey: 'page.medconnectAgent.tools.list_patient_prescriptions_desc',
    },

    // Staff Tools
    {
        name: 'query_doctors',
        titleKey: 'page.medconnectAgent.tools.query_doctors_title',
        category: ToolCategory.STAFF,
        descriptionKey: 'page.medconnectAgent.tools.query_doctors_desc',
    },
    {
        name: 'search_staff',
        titleKey: 'page.medconnectAgent.tools.search_staff_title',
        category: ToolCategory.STAFF,
        descriptionKey: 'page.medconnectAgent.tools.search_staff_desc',
    },
    {
        name: 'get_doctor_details',
        titleKey: 'page.medconnectAgent.tools.get_doctor_details_title',
        category: ToolCategory.STAFF,
        descriptionKey: 'page.medconnectAgent.tools.get_doctor_details_desc',
    },
    {
        name: 'get_doctor_availabilities',
        titleKey: 'page.medconnectAgent.tools.get_doctor_availabilities_title',
        category: ToolCategory.STAFF,
        descriptionKey: 'page.medconnectAgent.tools.get_doctor_availabilities_desc',
    },
    {
        name: 'get_doctor_busy_slots',
        titleKey: 'page.medconnectAgent.tools.get_doctor_busy_slots_title',
        category: ToolCategory.STAFF,
        descriptionKey: 'page.medconnectAgent.tools.get_doctor_busy_slots_desc',
    },

    // Waiting Room Tools
    {
        name: 'query_waiting_rooms',
        titleKey: 'page.medconnectAgent.tools.query_waiting_rooms_title',
        category: ToolCategory.WAITING_ROOM,
        descriptionKey: 'page.medconnectAgent.tools.query_waiting_rooms_desc',
    },
    {
        name: 'get_waiting_room_details',
        titleKey: 'page.medconnectAgent.tools.get_waiting_room_details_title',
        category: ToolCategory.WAITING_ROOM,
        descriptionKey: 'page.medconnectAgent.tools.get_waiting_room_details_desc',
    },
    {
        name: 'add_patient_to_waiting_room',
        titleKey: 'page.medconnectAgent.tools.add_patient_to_waiting_room_title',
        category: ToolCategory.WAITING_ROOM,
        descriptionKey: 'page.medconnectAgent.tools.add_patient_to_waiting_room_desc',
    },

    // Form Tools
    {
        name: 'get_form_details',
        titleKey: 'page.medconnectAgent.tools.get_form_details_title',
        category: ToolCategory.FORM,
        descriptionKey: 'page.medconnectAgent.tools.get_form_details_desc',
    },
    {
        name: 'list_forms',
        titleKey: 'page.medconnectAgent.tools.list_forms_title',
        category: ToolCategory.FORM,
        descriptionKey: 'page.medconnectAgent.tools.list_forms_desc',
    },
    {
        name: 'submit_form',
        titleKey: 'page.medconnectAgent.tools.submit_form_title',
        category: ToolCategory.FORM,
        descriptionKey: 'page.medconnectAgent.tools.submit_form_desc',
    },

    // Vidal (Drug Database) Tools
    {
        name: 'vidal_search_drug',
        titleKey: 'page.medconnectAgent.tools.vidal_search_drug_title',
        category: ToolCategory.VIDAL,
        descriptionKey: 'page.medconnectAgent.tools.vidal_search_drug_desc',
    },
    {
        name: 'vidal_get_drug_details',
        titleKey: 'page.medconnectAgent.tools.vidal_get_drug_details_title',
        category: ToolCategory.VIDAL,
        descriptionKey: 'page.medconnectAgent.tools.vidal_get_drug_details_desc',
    },

    // Knowledge Base (RAG) Tools
    {
        name: 'listKnowledgeBaseCollections',
        titleKey: 'page.medconnectAgent.tools.listKnowledgeBaseCollections_title',
        category: ToolCategory.KNOWLEDGE_BASE,
        descriptionKey: 'page.medconnectAgent.tools.listKnowledgeBaseCollections_desc',
    },
    {
        name: 'vectorSearch',
        titleKey: 'page.medconnectAgent.tools.vectorSearch_title',
        category: ToolCategory.KNOWLEDGE_BASE,
        descriptionKey: 'page.medconnectAgent.tools.vectorSearch_desc',
    },

    // Meta Tools
    {
        name: 'get_current_time',
        titleKey: 'page.medconnectAgent.tools.get_current_time_title',
        category: ToolCategory.META,
        descriptionKey: 'page.medconnectAgent.tools.get_current_time_desc',
    },
    {
        name: 'list_available_tools',
        titleKey: 'page.medconnectAgent.tools.list_available_tools_title',
        category: ToolCategory.META,
        descriptionKey: 'page.medconnectAgent.tools.list_available_tools_desc',
    },
    {
        name: 'think',
        titleKey: 'page.medconnectAgent.tools.think_title',
        category: ToolCategory.META,
        descriptionKey: 'page.medconnectAgent.tools.think_desc',
    },
] 